import { createInventoryBrandPage } from "../../../components/create-inventory-brand-page";
import db from "../../../utils/parts-parker.json";
export default createInventoryBrandPage("parker");

export async function getStaticProps() {
	return { props: { db } };
}
